import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../contexts/I18nContext";
import { SUPPORT_WHATSAPP } from "../../lib/whatsapp";
import { Crown, Mail, MessageCircle, Shield, FileText, RefreshCcw, Info, BookOpen, ShieldCheck } from "lucide-react";

export default function Footer() {
  const { t, lang } = useI18n();
  const ar = lang === "ar";
  return (
    <footer className="mt-24 border-t border-white/10" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-12 grid md:grid-cols-4 gap-8 text-sm text-white/60">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-full" style={{ background: "linear-gradient(135deg, #F9E596, #AA8000)" }}>
              <Crown className="h-4 w-4 text-black" />
            </span>
            <span className="text-lg font-black gold-text">{t("app_name")}</span>
          </div>
          <p className="text-xs leading-relaxed">{t("legal_note")}</p>
          <p className="text-[10px] text-white/40 mt-3 leading-relaxed">
            {ar ? "دولة قطر · الدوحة" : "State of Qatar · Doha"}
          </p>
        </div>

        <div className="flex flex-col gap-2.5">
          <span className="text-white/90 font-semibold uppercase tracking-wider text-xs mb-1">{t("app_name")}</span>
          <Link to="/leaderboard" className="hover:text-[#D4AF37] transition" data-testid="footer-leaderboard">{t("leaderboard")}</Link>
          <Link to="/catalog" className="hover:text-[#D4AF37] transition" data-testid="footer-catalog">{t("catalog")}</Link>
          <Link to="/subscribe" className="hover:text-[#D4AF37] transition" data-testid="footer-subscribe">{t("subscribe")}</Link>
          <Link to="/about" className="hover:text-[#D4AF37] transition inline-flex items-center gap-1.5" data-testid="footer-about">
            <Info className="h-3.5 w-3.5" /> {ar ? "من نحن" : "About"}
          </Link>
          <Link to="/how-it-works" className="hover:text-[#D4AF37] transition inline-flex items-center gap-1.5" data-testid="footer-how">
            <BookOpen className="h-3.5 w-3.5" /> {ar ? "كيف يعمل ثقة" : "How it works"}
          </Link>
        </div>

        <div className="flex flex-col gap-2.5">
          <span className="text-white/90 font-semibold uppercase tracking-wider text-xs mb-1">Legal</span>
          <Link to="/privacy" className="hover:text-[#D4AF37] transition inline-flex items-center gap-1.5" data-testid="footer-privacy">
            <Shield className="h-3.5 w-3.5" /> {t("privacy_policy")}
          </Link>
          <Link to="/terms" className="hover:text-[#D4AF37] transition inline-flex items-center gap-1.5" data-testid="footer-terms">
            <FileText className="h-3.5 w-3.5" /> {t("terms_of_service")}
          </Link>
          <Link to="/eula" className="hover:text-[#D4AF37] transition inline-flex items-center gap-1.5" data-testid="footer-eula">
            <FileText className="h-3.5 w-3.5" /> EULA
          </Link>
          <Link to="/refund" className="hover:text-[#D4AF37] transition inline-flex items-center gap-1.5" data-testid="footer-refund">
            <RefreshCcw className="h-3.5 w-3.5" /> {ar ? "سياسة الاسترجاع" : "Refund Policy"}
          </Link>
          <Link to="/guidelines" className="hover:text-[#D4AF37] transition inline-flex items-center gap-1.5" data-testid="footer-guidelines">
            <ShieldCheck className="h-3.5 w-3.5" /> {ar ? "إرشادات المحتوى" : "Community Guidelines"}
          </Link>
        </div>

        <div className="flex flex-col gap-2.5">
          <span className="text-white/90 font-semibold uppercase tracking-wider text-xs mb-1">{t("contact_support")}</span>
          <Link to="/contact" className="hover:text-[#D4AF37] transition inline-flex items-center gap-1.5" data-testid="footer-contact">
            <Mail className="h-3.5 w-3.5" /> {ar ? "تواصل معنا" : "Contact us"}
          </Link>
          <a href={`https://wa.me/${SUPPORT_WHATSAPP}`} target="_blank" rel="noreferrer" className="hover:text-emerald-400 transition inline-flex items-center gap-1.5" data-testid="footer-whatsapp">
            <MessageCircle className="h-3.5 w-3.5" /> {t("whatsapp_support")}
          </a>
          <a href="mailto:support@thaqh.com" className="hover:text-[#D4AF37] transition inline-flex items-center gap-1.5" data-testid="footer-email">
            <Mail className="h-3.5 w-3.5" /> support@thaqh.com
          </a>
        </div>
      </div>
      <div className="border-t border-white/5 py-5">
        <div className="mx-auto max-w-7xl px-5 text-xs text-white/40 text-center">
          © {new Date().getFullYear()} Thqah / ثقة · {ar ? "دولة قطر" : "State of Qatar"} · All rights reserved.
        </div>
      </div>
    </footer>
  );
}
